import { Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { formatTimeForSessionTimer } from '../../util'
import { AudioLevelClient } from '../audio-level-client'
import { AudioLevelClinician } from '../audio-level-clinician'
import { AutoStopTimer } from '../auto-stop-timer'

export const RecordingSettings = ({
  isMobileBreakpoint,
  isMuted,
  isTabAudioStreamOpen,
  recordingDuration,
  isStopRecordingAfterEnabled,
  recordingStartedAt
}: {
  isMobileBreakpoint: boolean
  isMuted: boolean
  isTabAudioStreamOpen: boolean
  recordingDuration: number
  isStopRecordingAfterEnabled: boolean
  recordingStartedAt: string
}) => {
  return (
    <VStack
      flex={isMobileBreakpoint ? '5' : '1'}
      data-testid="centered-session-timer-controls"
    >
      <Text
        fontSize="16px"
        style={{ marginTop: 0 }}
        color={isMuted ? '#282828' : 'primary'}
      >
        {isMuted ? 'Recording paused' : 'Recording in progress'}
      </Text>
      <Text
        width="100%"
        color={isMuted ? '#282828' : 'primary'}
        fontSize="88px"
        fontWeight="300"
        sx={{
          fontVariantNumeric: 'oldstyle-nums tabular-nums'
        }}
      >
        {formatTimeForSessionTimer(recordingDuration)}
      </Text>
      {!isTabAudioStreamOpen && <AudioLevelClinician showLabel={false} />}
      {!isMuted && (
        <Text mt="0px" fontSize="16px" color="#757575">
          A progress note will be generated after you
          <br />
          end the session.
        </Text>
      )}
      {isMuted && (
        <Text fontSize="16px" paddingTop="8px" color="#757575">
          Your notes won't include the conversation
          <br />
          that took place during this period.
        </Text>
      )}
      {isTabAudioStreamOpen && (
        <VStack gap="32px" mt="32px !important">
          <AudioLevelClinician showLabel={true} />
          <AudioLevelClient />
        </VStack>
      )}
      {isStopRecordingAfterEnabled && (
        <AutoStopTimer recordingStartedAt={recordingStartedAt} />
      )}
    </VStack>
  )
}
